<script lang="ts">
  import { pop } from "svelte-spa-router";
  import ListNavigationItem from "$shared/components/ListNavigationItem.svelte";
  import Separator from "$shared/components/Separator.svelte";
  import CardInline from "$shared/components/CardInline.svelte";
  import type {
    MyPagesQueueApplication,
    MyPagesStart,
    Tag,
  } from "../../../apis/parkito";
  import { daysSince, formatDate } from "$shared/utils/dateTime";
  import {
    getApplicantTagNames,
    getApplicantVolitionTags,
    translateVolitionType,
  } from "$shared/utils/misc";
  import { withApi } from "$shared/lib/api-parkito";
  import { Toast } from "$components";

  export let params: { applicantId: string };
  export let myPagesData: SvelteStore<MyPagesStart> | undefined;
  let queueApplicant: MyPagesQueueApplication | undefined = undefined;
  let tags: Tag[] = [];

  const getQueueTags = async (queueId: string) => {
    const tagsRes = await withApi((api) => {
      return api.queueGetAvailability(queueId, {});
    });

    if (tagsRes.isOk()) {
      tags = tagsRes.value.tags.map((qt) => qt.tag);
    } else {
      Toast.error("Kunde inte hämta taggar");
    }
  };

  $: {
    if ($myPagesData && $myPagesData.applicants.length > 0) {
      queueApplicant = $myPagesData.applicants.find(
        (a: any) => a.id === params.applicantId,
      );
      getQueueTags(queueApplicant?.queueId ?? "");
    }
  }
</script>

<div>
  <div class="px-[24px] py-[24px] max-mobile:px-[8px] max-mobile:py-[8px]">
    <button
      on:click={() => {
        pop();
      }}
      class="-ml-[8px] min-[480px]:hidden"
    >
      <img
        src="./icons/arrow-left-small.svg"
        class="w-[24px] inline p-[8px] pb-[11px]"
        alt="arrow-left"
      />
    </button>
    <h2 class="text-[#181818] text-[17px] -mt-[30px] inline relative">
      {queueApplicant?.queueName ?? "-"}
    </h2>
  </div>
  <Separator customClass="max-mobile:hidden" />

  <div
    class="w-full min-[840px]:columns-2 columns-1 p-[24px] max-mobile:px-[8px]"
  >
    {#if queueApplicant}
      <CardInline title="Intresseanmälan">
        <div>
          <ListNavigationItem
            title="Registrerade intresse"
            textRight={formatDate(queueApplicant?.createdAt, "YYYY-MM-DD")}
            isFirst={true}
          />
          <ListNavigationItem
            title="Kötid"
            textRight={`${daysSince(queueApplicant?.createdAt)} dagar`}
          />
          <ListNavigationItem
            title="Anledning till ansökan"
            textRight={translateVolitionType(queueApplicant?.volition)}
          />
          <ListNavigationItem
            title="Intresse för produkter"
            textRight={getApplicantTagNames(
              tags ?? [],
              getApplicantVolitionTags(queueApplicant),
            )}
          />
          <ListNavigationItem
            title="Önskat startdatum"
            textRight={formatDate(
              queueApplicant?.preferredStartDate,
              "YYYY-MM-DD",
            )}
          />
          <ListNavigationItem
            title="Har fått erbjudande"
            textRight="n/a"
            isLast={true}
          />
        </div>
      </CardInline>
    {/if}
  </div>
</div>
